<template>
  <div>
    <div class="px-2">
      <div class="pt-2 user-note"
           contenteditable="true"
           @input="edit()"
           :ref="`note-${index}`">
        {{ item.value }}
      </div>
    </div>

    <div class="pa-2"
         style="display: flex; justify-content: space-between">
      <div>
        <div class="kbGrayText--text"
             style="font-size: 12px; text-decoration: none">
          {{ item.user.name }}
        </div>

        <!-- Displaying note creation date -->
        <div class="kbGrayText--text"
             style="font-size: 12px">
          {{ $t('general.date') }}: {{ item.date }}
        </div>

        <!-- Displaying note creation hour -->
        <div class="kbGrayText--text"
             style="font-size: 12px">
          {{ $t('general.hour') }}: {{ item.hour }}
        </div>
      </div>

      <div>
        <v-tooltip bottom
                   v-if="editing">
          <template v-slot:activator="{ on }">
            <v-btn @click="cancel()"
                   color="red"
                   icon
                   v-on="on">
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </template>

          <span>
            {{ $t('general.cancel') }}
          </span>
        </v-tooltip>

        <v-tooltip bottom v-if="editing">
          <template v-slot:activator="{ on }">
            <v-btn color="green"
                   icon
                   v-on="on"
                   @click="update()">
              <v-icon>
                mdi-check
              </v-icon>
            </v-btn>
          </template>

          <span>
            {{ $t('general.save') }}
          </span>
        </v-tooltip>

        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <v-btn color="red"
                   icon
                   v-on="on"
                   @click="remove()">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>

          <span>
            {{ $t('general.deleteNote') }}
          </span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    editing: false
  }),
  methods: {
    cancel () {
      this.editing = false
      this.$refs[`note-${this.index}`].innerText = this.item.value
    },
    edit () {
      this.editing = true
    },
    remove () {
      this.$emit('remove')
    },
    update () {
      this.editing = false
      this.$emit('update', this.$refs[`note-${this.index}`].innerText)
    }
  },
  props: ['index', 'item']
}
</script>

<style>
.user-note:focus {
  outline: none;
}
</style>
